module.exports = __webpack_public_path__ + "static/media/coding.0144a6e1.jpg";